import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";

export const SIZE = 30;
export const PROGRESS_HEIGHT = 7;
export const BORDER_RADIUS = 4;

export default function ProgressBlock({
  children,
  percent,
  highlighted,
  selected,
}) {
  return (
    <CenterDiv data-cy="progressBlock">
      <SuperWrapper selected={selected} highlighted={highlighted}>
        <ProgressBar percent={percent} />
        {children}
      </SuperWrapper>
    </CenterDiv>
  );
}

ProgressBlock.propTypes = {
  children: PropTypes.any,
  highlighted: PropTypes.object,
  percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  selected: PropTypes.bool,
};

export function gradient({ percent, theme: { orange, green } }) {
  return css`
    /**
     * Gradient source permalink
     * http://colorzilla.com/gradient-editor/#e68058+50,1d845f+50
     */
    /* FF3.6-15 */
    background: -moz-linear-gradient(
      left,
      ${orange} ${percent}%,
      ${green} ${percent}%
    );
    /* Chrome10-25, Safari5.1-6 */
    background: -webkit-linear-gradient(
      left,
      ${orange} ${percent}%,
      ${green} ${percent}%
    );
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    background: linear-gradient(
      to right,
      ${orange} ${percent}%,
      ${green} ${percent}%
    );
  `;
}

const CenterDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const SuperWrapper = styled.div`
  width: 30px;
  height: 24px;
  z-index: 1;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${BORDER_RADIUS}px;
  position: relative;
  //margin-top: -11px;
  flex-shrink: 0;
  flex-grow: 0;
  background-color: white;

  ${({ selected, theme }) =>
    selected && `background-color: ${theme.hoverColor}`};

  ${({ theme, highlighted }) =>
    highlighted &&
    `
    &:hover {
      background-color ${theme.hoverColor};
      }
  `};
`;

const ProgressBar = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  height: ${PROGRESS_HEIGHT}px;
  background-color: ${({ theme }) => theme.green};
  position: absolute;
  border-top-left-radius: ${BORDER_RADIUS}px;
  border-top-right-radius: ${BORDER_RADIUS}px;
  width: calc(100% + 2px) !important;
  top: -5px;
  left: -1px;
  ${gradient};
`;
